import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { PageButtonHeader } from "../../styles/page";
import {
  ManagementEditBox,
  ManagementEditWrapper,
  ManagementEditItem,
  EditInputBox,
  ManagementEditRow,
  EditImageBox,
  EditFacilitiesWrapper,
  EditFacilitiesItem,
  ManagementEditPoster,
  PosterImageWrapper,
  EditPosterImageBox,
  ManagementOtherSetting,
  ManagementPageWrapper,
} from "./styles";
import { pubState } from "../../recoil/pub.atom";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import {
  CafeSellerMetadataUpdateRequest,
  deleteSellerPubEventImage,
  deleteSellerPubImage,
  PubOwnerDomain,
  PubOwnerRole,
  pushSellerPubEventImage,
  pushSellerPubImage,
  sellerPub,
  updateSellerPub,
} from "../../api/cafe";
import { UserState } from "../../recoil/user.atom";
import { dialogState } from "../../recoil/dialog.atom";
import DetailInfoPopup from "./component/detailInfo";
import ManageMentPreview from "./component/preview";
import StaffPopup from "./component/staff";
import { Overlay } from "../../styles/popup";
import { useNavigate } from "react-router-dom";
const facilitiesObject = [
  {
    id: 1,
    type: "WIFI",
    name: "와이파이",
  },
  {
    id: 2,
    type: "PARKING",
    name: "주차가능",
  },
  {
    id: 3,
    type: "SMOKING",
    name: "흡연실",
  },
  {
    id: 4,
    type: "FOOD",
    name: "식사제공",
  },
  {
    id: 8,
    type: "REST_AREA",
    name: "휴게실",
  },
  {
    id: 9,
    type: "COFFEE",
    name: "커피제공",
  },
];

const ManageMent = () => {
  const [pub, setPub] = useRecoilState(pubState);
  const user = useRecoilValue(UserState);
  const [directions, setDirections] = useState(pub ? pub.directions : "");
  const [informationUse, setInformationUse] = useState(
    pub ? pub.informationUse : "",
  );
  const [naverPlaceUrl, setNaverPlaceUrl] = useState(pub?.naverPlaceUrl ?? "");
  const setDialog = useSetRecoilState(dialogState);
  const [images, setImages] = useState<string[]>(
    pub?.images ? pub.images.map((image) => image.imageUrl) : [],
  );
  const [posterImages, setPosterImages] = useState<string[]>(
    pub?.events ? pub.events.map((event) => event.imageUrl) : [],
  );
  const [facilities, setFacilities] = useState<string[]>(
    pub?.facilities ? pub.facilities : [],
  );
  const [isLiveSettingOpen, setIsLiveSettingOpen] = useState(false);
  const [isDetailInfoOpen, setIsDetailInfoOpen] = useState(false);
  const [isStaffManagementOpen, setIsStaffManagementOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.MANAGEMENT)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const isFacilitiesActive = (type: string) => {
    if (facilities.some((facility) => facility === type)) {
      return true;
    } else {
      return false;
    }
  };

  const selectFacilities = (type: string) => {
    if (facilities.some((facility) => facility === type)) {
      const updatedFacilities = facilities.filter(
        (facility) => facility !== type,
      );
      setFacilities(updatedFacilities);
    } else {
      const facilityToAdd = facilitiesObject.find(
        (facility) => facility.type === type,
      );

      if (facilityToAdd) {
        setFacilities([...facilities, facilityToAdd.type]);
      }
    }
  };

  const deleteImage = async (imageUrl: string) => {
    if (!pub) return;
    setDialog({
      title: "정말 삭제하시겠습니까?",
      confirm: async () => {
        try {
          await deleteSellerPubImage(pub.id, imageUrl);
          const image = images.filter((images) => images !== imageUrl);
          setImages(image);
        } catch (e) {
          alert("일시적인 서버 문제가 발생했습니다.");
        }
      },
    });
  };

  const deletePosterImage = async (imageUrl: string) => {
    if (!pub) return;
    setDialog({
      title: "정말 삭제하시겠습니까?",
      confirm: async () => {
        try {
          await deleteSellerPubEventImage(pub.id, imageUrl);
          const image = posterImages.filter((images) => images !== imageUrl);
          setPosterImages(image);
        } catch (e) {
          alert("일시적인 서버 문제가 발생했습니다.");
        }
      },
    });
  };

  const updatePub = async () => {
    if (!pub) return;
    const request: CafeSellerMetadataUpdateRequest = {
      cafeId: pub.id,
      directions,
      facilities: facilities,
      informationUse,
      naverPlaceUrl,
    };
    await updateSellerPub(request);

    alert("수정되었습니다.");
    if (!user) return;
    const res = await sellerPub(pub.id);
    if (res) {
      setPub(res);
    }
  };

  useEffect(() => {
    if (isDetailInfoOpen || isStaffManagementOpen) {
      const rootElement = document.getElementById("managementPage");
      if (rootElement) {
        rootElement.scrollTo(0, 0);
      }
    }
  }, [isDetailInfoOpen, isStaffManagementOpen]);

  const handleImage = async (files: FileList | null) => {
    if (!pub || !files) return;
    let formData = new FormData();
    formData.append("imageFile", files[0]);
    try {
      await pushSellerPubImage(pub?.id, formData);
      const res = await sellerPub(pub.id);
      if (res) {
        setPub(res);
        setImages(res.images.map((image) => image.imageUrl));
      }
    } catch (e: any) {
      alert(e.message);
      console.error(e);
    }
  };

  return (
    <ManagementPageWrapper
      id="managementPage"
      style={{
        overflowY:
          isDetailInfoOpen || isStaffManagementOpen ? "hidden" : "auto",
      }}
    >
      {(isDetailInfoOpen || isLiveSettingOpen || isStaffManagementOpen) && (
        <Overlay />
      )}
      {isDetailInfoOpen && (
        <DetailInfoPopup setIsDetailInfoOpen={setIsDetailInfoOpen} />
      )}
      {isStaffManagementOpen && (
        <StaffPopup setIsStaffManagementOpen={setIsStaffManagementOpen} />
      )}
      <ManagementEditWrapper>
        <PageButtonHeader>
          <span>펍 관리</span>
          <div className="button" onClick={() => updatePub()}>
            저장하기
          </div>
        </PageButtonHeader>
        <ManagementEditBox>
          <ManagementEditRow>
            <ManagementEditItem isAlignCenter={true}>
              <div className="title">펍 이름</div>
              <EditInputBox active={false}>
                <input type="text" value={pub?.cafeName} disabled />
              </EditInputBox>
            </ManagementEditItem>
            <ManagementEditItem isAlignCenter={true}>
              <div className="title">대표자명</div>
              <EditInputBox active={false}>
                <input type="text" disabled value={pub?.ownerName} />
              </EditInputBox>
            </ManagementEditItem>
          </ManagementEditRow>
          <ManagementEditRow>
            <ManagementEditItem isAlignCenter={true}>
              <div className="title">주소</div>
              <EditInputBox active={false}>
                <input
                  type="text"
                  value={`${pub?.newAddress} ${pub?.detailAddress}`}
                  disabled
                />
              </EditInputBox>
            </ManagementEditItem>
          </ManagementEditRow>
          <ManagementEditRow>
            <ManagementEditItem isAlignCenter={true}>
              <div className="title">전화번호</div>
              <EditInputBox active={false}>
                <input
                  type="text"
                  value={`${pub?.phoneNumber}  (${pub?.vcn})`}
                  disabled
                />
              </EditInputBox>
            </ManagementEditItem>
          </ManagementEditRow>
          <ManagementEditRow>
            <ManagementEditItem isAlignCenter={true}>
              <div className="title">네이버 플레이스 URL</div>
              <EditInputBox active={true}>
                <input
                  type="text"
                  value={naverPlaceUrl}
                  placeholder="네이버 플레이스 URL을 입력하세요."
                  onChange={(e) => setNaverPlaceUrl(e.target.value)}
                />
              </EditInputBox>
            </ManagementEditItem>
          </ManagementEditRow>
          <ManagementEditRow addMargin={true}>
            <ManagementEditItem isAlignCenter={false}>
              <div className="title">매장사진</div>
              <div
                className="select-image"
                onClick={() => {
                  const fileInput = document.getElementById("fileInput");
                  if (fileInput) {
                    fileInput.click();
                  }
                }}
              >
                <img src="/image-web/management/file.svg" />
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  accept=".jpg, .jpeg, .png"
                  onChange={async (e) => {
                    handleImage(e.target.files);
                  }}
                />
              </div>
              <Swiper
                slidesPerView={"auto"}
                centeredSlides={false}
                spaceBetween={20}
                direction="horizontal"
                className="swiper"
              >
                {images.map((item, index) => {
                  return (
                    <SwiperSlide key={index} className="swiper-slide">
                      <EditImageBox image={item}>
                        <img
                          src="/image-web/management/delete.svg"
                          onClick={() => deleteImage(item)}
                        />
                      </EditImageBox>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </ManagementEditItem>
          </ManagementEditRow>
          <ManagementEditRow addMargin={true}>
            <ManagementEditItem isAlignCenter={false}>
              <div className="title">매장 이용안내</div>
              <EditInputBox active={true}>
                <textarea
                  spellCheck={false}
                  value={informationUse}
                  onChange={(e) => {
                    setInformationUse(e.target.value);
                  }}
                />
              </EditInputBox>
            </ManagementEditItem>
          </ManagementEditRow>
          <ManagementEditRow addMargin={true}>
            <ManagementEditItem isAlignCenter={false}>
              <div className="title" />
              <EditFacilitiesWrapper>
                {facilitiesObject.map((item, index) => (
                  <EditFacilitiesItem
                    onClick={() => selectFacilities(item.type)}
                    active={isFacilitiesActive(item.type)}
                  >
                    <img src={`/image-web/management/${item.type}.svg`} />
                    <div className="title">{item.name}</div>
                  </EditFacilitiesItem>
                ))}
              </EditFacilitiesWrapper>
            </ManagementEditItem>
          </ManagementEditRow>
          <ManagementEditRow addMargin={true}>
            <ManagementEditItem isAlignCenter={false}>
              <div className="title" />
              <EditFacilitiesWrapper>
                <ManagementOtherSetting>
                  <div
                    className="button"
                    onClick={() => {
                      setIsDetailInfoOpen(true);
                    }}
                  >
                    상세 정보 입력하기
                  </div>
                </ManagementOtherSetting>
                <ManagementOtherSetting>
                  <div
                    className="button"
                    onClick={() => {
                      setIsStaffManagementOpen(true);
                    }}
                  >
                    직원 관리
                  </div>
                </ManagementOtherSetting>
              </EditFacilitiesWrapper>
            </ManagementEditItem>
          </ManagementEditRow>
        </ManagementEditBox>
        <ManagementEditPoster>
          <div className="title">이벤트 포스터 등록</div>
          <PosterImageWrapper>
            <div
              className="input-box"
              onClick={() => {
                const fileInput = document.getElementById("posterFileInput");
                if (fileInput) {
                  fileInput.click();
                }
              }}
            >
              <img src="/image-web/management/poster-file.svg" />
              <input
                type="file"
                id="posterFileInput"
                style={{ display: "none" }}
                accept=".jpg, .jpeg, .png"
                onChange={async (e) => {
                  if (!pub || !e.target.files) return;
                  let formData = new FormData();
                  formData.append("imageFile", e.target.files[0]);
                  const res = await pushSellerPubEventImage(pub?.id, formData);
                  const list = [...posterImages];
                  list.push(res.message);
                  setPosterImages(list);
                }}
              />
            </div>
            <Swiper
              slidesPerView={"auto"}
              centeredSlides={false}
              spaceBetween={20}
              direction="horizontal"
              className="swiper"
            >
              {posterImages.map((item, index) => {
                return (
                  <SwiperSlide key={index} className="swiper-slide">
                    <EditPosterImageBox image={item}>
                      <img
                        src="/image-web/management/delete.svg"
                        onClick={() => deletePosterImage(item)}
                      />
                    </EditPosterImageBox>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </PosterImageWrapper>
        </ManagementEditPoster>
      </ManagementEditWrapper>{" "}
      <ManageMentPreview />
    </ManagementPageWrapper>
  );
};
export default ManageMent;
